import React from 'react';
import { LAUNCH_PRICE_ENDS, PRICE, PRICE_AFTER_LAUNCH, UrgencyVariant } from '../data/offer';
type UrgencyProps = {
  variant?: UrgencyVariant;
};

/**
 * No countdown, no scarcity bar, by decision. Option A ('launch-price') may
 * only ship if the date and the increase are real and executed.
 */
export function Urgency({
  variant = 'none'
}: UrgencyProps) {
  if (variant === 'launch-price') {
    return <section aria-labelledby="urgency-heading" className="w-full bg-sage text-white" data-id="element-267" data-mp="1o61yzcjzride">
        <div className="max-w-3xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-id="element-268" data-mp="1sy1zb63z4dai">
          <p id="urgency-heading" className="text-xs sm:text-sm font-semibold uppercase tracking-[0.14em] text-white/70" data-id="element-269" data-mp="1e95q35q6ku8b">
            Launch price
          </p>
          <p className="mt-4 font-serif text-xl sm:text-3xl leading-snug" data-id="element-270" data-mp="1587o0szaywsd">
            {PRICE} is the launch price. On {LAUNCH_PRICE_ENDS} it goes to{' '}
            {PRICE_AFTER_LAUNCH} and stays there.
          </p>
          <p className="mt-5 text-white/80 leading-relaxed" data-id="element-271" data-mp="25yr07p1sioo2">
            No countdown on this page, because a timer that resets for every
            visitor isn&apos;t a deadline — it&apos;s a costume.
          </p>
        </div>
      </section>;
  }
  return <section aria-labelledby="urgency-heading" className="w-full bg-sage text-white" data-id="element-272" data-mp="2fv3uop55t6jv">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-id="element-273" data-mp="2awageui1tbin">
        <h2 id="urgency-heading" className="font-serif font-bold text-2xl sm:text-4xl" data-id="element-274" data-mp="1n9kj26gna54d">
          Why this costs {PRICE}
        </h2>
        <p className="mt-6 text-white/85 text-base sm:text-lg leading-relaxed" data-id="element-275" data-mp="1wyc7i4mhy7aj">
          Because the goal isn&apos;t to catch you on an impulse. It&apos;s to
          be the last operations system you have to buy — and the price of the
          last planner you abandoned is roughly what this costs. There&apos;s no
          timer on this page and no countdown in your browser. It&apos;ll be
          here tomorrow.{' '}
          <strong className="text-white font-semibold" data-id="element-276" data-mp="1p6asr17ssm25">
            The question is whether next Sunday looks like the last one.
          </strong>
        </p>
      </div>
    </section>;
}